/* Aspilon blog: "Load more articles" is a normal link to the next page; this script fetches that page and appends its
   cards. Without JavaScript the link simply opens the next page. Triggered by a click only. */
(() => {
  const more = document.querySelector('[data-aspilon-more]');
  if (!more) return;
  const container = more.parentElement;

  more.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-aspilon-more-link]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(link.href, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(String(response.status));
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const items = [...doc.querySelectorAll('.blog-posts-container > .blog-post-item')];
      if (!items.length) throw new Error('empty');

      items.forEach((item) => container.insertBefore(document.importNode(item, true), more));

      const shown = container.querySelector('[data-aspilon-shown]');
      const nextShown = doc.querySelector('[data-aspilon-shown]');
      if (shown && nextShown) shown.textContent = nextShown.textContent;

      const nextLink = doc.querySelector('[data-aspilon-more-link]');
      if (nextLink) {
        link.href = nextLink.href;
        link.removeAttribute('aria-busy');
      } else {
        more.remove();
      }

      const firstNew = container.querySelectorAll('.blog-post-item')[container.querySelectorAll('.blog-post-item').length - items.length];
      const firstLink = firstNew && firstNew.querySelector('a');
      if (firstLink) firstLink.focus({ preventScroll: false });
    } catch (error) {
      window.location.href = link.href;
    }
  });
})();
